import { render, staticRenderFns } from "./pays.vue?vue&type=template&id=60c42b0d&scoped=true&"
import script from "./pays.vue?vue&type=script&lang=js&"
export * from "./pays.vue?vue&type=script&lang=js&"
import style0 from "./pays.vue?vue&type=style&index=0&id=60c42b0d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c42b0d",
  null
  
)

export default component.exports